import React, { useState, useEffect, use } from "react";
import LogoSlider from "../Components/LogoSlider";
import Accordion from "../Components/Accordion";
import ReviewSlider from "../Components/ReviewSlider";
import ReviewSlider2 from "../Components/ReviewSlider2";
import { motion, AnimatePresence } from "framer-motion";
import Gallery from "../Components/Gallery";
import Events from "../Components/Events";
import { Create_Api } from "../API_URL";
import { toast } from "react-toastify";
import Blogs from "../Components/Blogs";
import { useNavigate } from "react-router-dom";
const ourList = [
  { name: "Business", link: "" },
  { name: "Technology", link: "" },
  { name: "Management", link: "" },
  { name: "Finance", link: "" },
];
function Home() {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(true);
  }, []);

  const [ourButton, setOurButton] = useState("Business");

  const [Name, setName] = useState('');
  const [Email, setEmail] = useState('');
  const [Number, setNumber] = useState('');
  const [Message, setMessage] = useState('');
  const [IsUploading, setIsUploading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!Name) return toast.error('Name is required');
    if (!Email) return toast.error('Email is required');
    if (!Number) return toast.error('Number is required');
    if (!/^\d{10}$/.test(Number)) return toast.error('Number must be exactly 10 digits');
    if (!Message) return toast.error('Message is required');

    setIsUploading(true);

    const Data = {
      Name,
      Email,
      Number,
      Message
    }

    try {
      const response = await Create_Api('api/admin/CreateContactUs', Data);
      toast.success(response?.message || 'Contact Form Submitted!');
      setName('');
      setEmail('');
      setNumber('');
      setMessage('');
      navigate('/Thankyou');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to add Blogs.');
      console.error('Error creating Blogs:', error);
    } finally {
      setIsUploading(false);
    }
  };


  return (
    <>
      <AnimatePresence>
        {showModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50" style={{ zIndex: '100' }}>
            <motion.div
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -50 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
              className="bg-white p-6 rounded-lg shadow-lg w-96"
            >
              <div className="modal-heading">
                <img style={{ height: '80px' }} src="/assets/new logo.png" />
                <button
                  className="  "
                  onClick={() => setShowModal(false)}
                >
                  <i class="bi bi-x-circle"></i>
                </button>
              </div>
              <br/>
              <div className="modal-input">
                <input
                  placeholder="Enter Your Name"
                  className=""
                  value={Name}
                  onChange={(e) => { setName(e.target.value) }}
                />
                <input
                  placeholder="Enter Your Email"
                  className=""
                  value={Email}
                  onChange={(e) => { setEmail(e.target.value) }}
                />
                <input
                  placeholder="Enter Your Mobile No."
                  className=""
                  type="number"
                  value={Number}
                  onChange={(e) => { setNumber(e.target.value) }}
                />
                <textarea
                  placeholder="Enter Your Message"
                  className=""
                  value={Message}
                  onChange={(e) => { setMessage(e.target.value) }}
                />
                <button onClick={(e) => { handleSubmit(e) }}>
                  {IsUploading ? "Please Wait" : "Send"}
                </button>

              </div>

              {/* <h2 className="text-xl font-bold" style={{textAlign:'center'}}>Let’s Connect Over Breakfast! </h2>

          <h2 className="text-xl font-bold " style={{textAlign:'center'}}>Business Breakfast Meet </h2>

          <br/>
            <p>
            Saturday 22/03/2025
            </p>
            <p>
            At 08:00 AM to 10:00 AM
            </p>

            <p>
            <b>Contact Details:</b> +91- 9811144064, 9202289202
            </p>
            <p>
            <b>Email: </b> ruby@vnimembers.com
            </p> */}
            </motion.div>
          </div>
        )}
      </AnimatePresence>
      <section className="hero-section" >
        <div className="absolute bottom-0 md:px-[120px] px-[20px] w-full">
          <div className="flex md:items-end items-center md:flex-row justify-between flex-col gap-[50px]">
            <div className="max-w-[674px] w-full ">
              <h1 className="font-[500] md:text-[50px] text-[32px] md:leading-[86.4px] leading-[40px] text-[#FFFFFF]">
                Empowering Businesses, Connecting Opportunities
              </h1>
              <p className="font-[400] text-[12px] leading-[24px] text-[#FFFFFF]">
                At VNI, we believe in the power of collaboration to drive success. Our dynamic network brings together entrepreneurs, professionals, and industry leaders, fostering meaningful connections that fuel growth. Join us to unlock new opportunities, gain valuable insights, and take your business beyond boundaries.
              </p>
            </div>
            <div className="max-w-[445px] w-full">
              <div className="lead-gen">
                <input
                  placeholder="Enter Your Name"
                  value={Name}
                  onChange={(e) => { setName(e.target.value) }}
                />
                <input
                  placeholder="Enter Your Email"
                  value={Email}
                  onChange={(e) => { setEmail(e.target.value) }}
                />
                <input
                  placeholder="Enter Your Mob No."
                  type="number"
                  value={Number}
                  onChange={(e) => { setNumber(e.target.value) }}
                />
                <textarea
                  placeholder="Enter Your Message"
                  value={Message}
                  onChange={(e) => { setMessage(e.target.value) }}
                ></textarea>
                <button onClick={(e) => { handleSubmit(e) }}>
                  {IsUploading ? "Please Wait" : "Send"}
                </button>

              </div>
            </div>
          </div>
          <hr className="bg-[#FFFFFF] opacity-50 my-[42px]" />
          <div className="grid md:grid-cols-2 grid-cols-1 items-center pb-[50px] md:gap-0 gap-[20px]">
            <div>
              <button className="relative font-[400] text-[16px] leading-[22px] text-center text-[#FFFFFF] py-[11px] px-[27px] border border-[#ffffff] rounded-[50px] ml-[15px]">
                Explore more
                <img
                  src="/assets/right-arrow.svg"
                  className="absolute right-[-28px] top-[50%] translate-y-[-50%]"
                  alt=""
                />
              </button>
            </div>
            <div className="flex gap-[30px] md:items-center md:flex-row flex-col justify-end">
              <div>
                <h6 className="font-[500] text-[24px] leading-[28.8px] md:text-right text-left text-[#FFFFFF] pb-[10px]">
                  1000+
                </h6>
                <p className="font-[400] text-[18px] leading-[27px] md:text-right text-left text-[#FFFFFF]">
                  Satisfied clients
                </p>
              </div>
              <div className="flex">
                <img
                  src="/assets/home/profile4.png"
                  className="mr-[-10px]"
                  alt=""
                />
                <img
                  src="/assets/home/profile2.png"
                  className="mr-[-10px]"
                  alt=""
                />
                <img src="/assets/home/profile1.png" alt="" />
                <img
                  src="/assets/home/profile3.png"
                  className="mr-[-10px]"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <br />
      <div className="event-heading md:px-[135px] px-[20px]">
        <h6 className="font-[500] text-[48px] leading-[57.6px] text-[#00725d] pb-[24px]">
          Upcoming <span className=" text-[#F8A340]"> Events</span>
        </h6>
      </div>
      <br />

      <Events />
      <br />

      <section className="md:px-[134px] px-[20px] md:pt-[110px]">
        <div className="flex items-center justify-between md:flex-row flex-col  md:pb-[60px] pb-[30px]">
          <div>
            <h6 className="font-[500] text-[48px] leading-[57.6px] text-[#00725d] pb-[24px]">
              About <span className=" text-[#F8A340]">VNI</span>
            </h6>
            <p className="max-w-[498px] w-full font-[400] text-[16px] leading-[24px] text-[#00725d]">
              Team Money Services is an <span className=" text-[#F8A340]"><b>ISO-certified</b> </span>financial solutions provider with over a decade of experience. Offering <span className=" text-[#F8A340]"><b>loans, insurance, mutual funds, and IPO advisory,</b> </span>  we tailor solutions to meet diverse client needs.
              ed by Director Arun Dabral, a visionary in the industry, we focus on innovation and financial empowerment, <span className=" text-[#F8A340]"><b>helping individuals and businesses achieve their goals with confidence.</b> </span>
            </p>
          </div>
          <button className="relative font-[400] text-[16px] leading-[22px] text-center text-[#FFFFFF] bg-[#00725d] py-[11px] px-[27px] border border-[#00725d] rounded-[50px] ml-[15px]">
            Explore more
            <img
              src="/assets/right-arrow.svg"
              className="absolute right-[-28px] top-[50%] translate-y-[-50%]"
              alt=""
            />
          </button>
        </div>
        <div className="flex items-center md:flex-row flex-col gap-[50px]">
          <div className="relative">
            <img src="/assets/home/img2.png" alt="" />
            <div className="absolute bottom-0 pb-[30px] w-full px-[30px] flex justify-between items-center">
              <div>
                <h6 className="font-[500] text-[28px] leading-[34px] text-[#FFFFFF] pb-[10px]">
                  Your goals take precedence above all
                </h6>
                <p className="font-[400] text-[400] text-[16px] leading-[24px] text-[#FFFFFF]">
                  3:25 min
                </p>
              </div>
              <img src="/assets/home/icon1.svg" alt="" />
            </div>
          </div>
          <div className="flex flex-col gap-[30px] max-w-[302px] w-full">
            <div className="pb-[32px] border-b border-[#AFAFAF80]">
              <h6 className="text-[#f8a340] font-[500] text-[50px] leading-[50px] pb-[10px]">
                18+
              </h6>
              <p className="font-[400] text-[18px] leading-[25.2px] text-[#00725d]">
                Global Members
              </p>
            </div>
            <div className="pb-[32px] border-b border-[#AFAFAF80]">
              <h6 className="text-[#f8a340] font-[500] text-[50px] leading-[50px] pb-[10px]">
                289+
              </h6>
              <p className="font-[400] text-[18px] leading-[25.2px] text-[#00725d]">
                Trusted partners
              </p>
            </div>
            <div className="pb-[32px] border-b border-[#AFAFAF80]">
              <h6 className="text-[#f8a340] font-[500] text-[50px] leading-[50px] pb-[10px]">
                1k+
              </h6>
              <p className="font-[400] text-[18px] leading-[25.2px] text-[#00725d]">
                Global Chapters
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="md:px-[134px] px-[20px] md:pt-[110px]">
        <div className="flex items-center justify-between md:flex-row flex-col  md:pb-[60px] pb-[30px] md:gap-0 gap-[20px]">
          <div>
            <h6 className="font-[500] text-[48px] leading-[57.6px] text-[#00725d] pb-[24px]">
              Why Choose <span className=" text-[#F8A340]">Us?</span>
            </h6>
            <p className="max-w-[498px] w-full font-[400] text-[16px] leading-[24px] text-[#00725d]">
              Become part of an exclusive network by receiving an invitation <span className=" text-[#F8A340]">to a VNI chapter.</span> Connect with dynamic<span className=" text-[#F8A340]"> professionals and explore new opportunities </span> for growth and collaboration.
            </p>
          </div>
          <button className="relative font-[400] text-[16px] leading-[22px] text-center text-[#f8a340] py-[11px] px-[27px] border border-[#f8a340] rounded-[50px] ml-[15px]">
            Explore more
            <img
              src="/assets/right-arrow.svg"
              className="absolute right-[-28px] top-[50%] translate-y-[-50%]"
              alt=""
            />
          </button>
        </div>
        <div className="pt-[62px] grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[30px]">
          <div className="bg-[#EFEFFD] rounded-[20px] p-[30px]">
            <div className="flex justify-end pb-[38px]">
              <img src="/assets/home/icon2.svg" alt="" />
            </div>
            <h6 className="font-[500] text-[30px] leading-[43.2px] text-[#00725d] pb-[40px]">
              Extensive Network &  <br /> Growth Opportunities
            </h6>
            <div className="flex justify-between">
              <h6 className="font-[500] text-[100px] leading-[120px] text-[#f8a340]">
                01
              </h6>
              <p className="max-w-[137px] w-full text-right text-[#00725d] font-[400] text-[15px] leading-[21.6px]">
                Connect with 100+ business delegates and unlock growth opportunities.
              </p>
            </div>
          </div>
          <div className="bg-[#EFEFFD] rounded-[20px] p-[30px]">
            <div className="flex justify-end pb-[38px]">
              <img src="/assets/home/icon2.svg" alt="" />
            </div>
            <h6 className="font-[500] text-[30px] leading-[43.2px] text-[#00725d] pb-[40px]">
              Gain Expert <br />Insights
            </h6>
            <div className="flex justify-between">
              <h6 className="font-[500] text-[100px] leading-[120px] text-[#f8a340]">
                02
              </h6>
              <p className="max-w-[137px] w-full text-right text-[#00725d] font-[400] text-[15px] leading-[21.6px]">
                Learn from industry leaders through structured training and mentorship.
              </p>
            </div>
          </div>
          <div className="bg-[#EFEFFD] rounded-[20px] p-[30px]">
            <div className="flex justify-end pb-[38px]">
              <img src="/assets/home/icon2.svg" alt="" />
            </div>
            <h6 className="font-[500] text-[30px] leading-[43.2px] text-[#00725d] pb-[40px]">
              Thrive in a <br /> Trusted Community
            </h6>
            <div className="flex justify-between">
              <h6 className="font-[500] text-[100px] leading-[120px] text-[#f8a340]">
                03
              </h6>
              <p className="max-w-[137px] w-full text-right text-[#00725d] font-[400] text-[15px] leading-[21.6px]">
                Build lasting relationships in an ethics-driven and transparent
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="overflow-hidden md:py-[50px] py-[40px]">
        <LogoSlider />
      </section>
      <section className="md:px-[134px] px-[20px]">
        <div className="flex items-center justify-between md:flex-row flex-col md:pb-[34px] pb-[30px] md:gap-0 gap-[30px]">
          <div>
            <h6 className="font-[500] text-[48px] leading-[57.6px] text-[#00725d] pb-[24px]">
              Our <span className=" text-[#F8A340]">Concept </span>
            </h6>
            <p className="max-w-[498px] w-full font-[400] text-[16px] leading-[24px] text-[#00725d]">
              Business Beyond Boundaries
            </p>
          </div>
          <button className="relative font-[400] text-[16px] leading-[22px] text-center text-[#f8a340] py-[11px] px-[27px] border border-[#f8a340] rounded-[50px] ml-[15px]">
            Explore more
            <img
              src="/assets/right-arrow.svg"
              className="absolute right-[-28px] top-[50%] translate-y-[-50%]"
              alt=""
            />
          </button>
        </div>
        {/* <div className="flex gap-[10px] flex-wrap pb-[40px]">
          {ourList?.map((e, i) => {
            return (
              <div key={i}>
                <button
                  onClick={() => setOurButton(e.name)}
                  className={`font-[400] text-[18px] leading-[18px] px-[16px] rounded-[50px] py-[7px] ${
                    e.name === ourButton
                      ? "text-[#FFFFFF] bg-[#f8a340] border-[#f8a340] border"
                      : "text-[#00725d] bg-transparent border-[#00725d] border"
                  }`}
                >
                  {e.name}
                </button>
              </div>
            );
          })}
        </div> */}
        <div className="relative mb-[30px]">
          <img
            src="/assets/home/img3.png"
            className="w-full md:h-full h-[480px] object-cover"
            alt=""
          />
          <img
            src="/assets/home/icon3.svg"
            className="absolute right-[20px] top-[20px]"
            alt=""
          />
          <div
            className="bg-[#FFFFFF66] rounded-[20px] absolute bottom-[30px] left-[30px] p-[30px] max-w-[70%] w-full"
            style={{ backdropFilter: "blur(5px)" }}
          >
            <h6 className="font-[500] md:text-[36px] text-[20px] md:leading-[43.2px] text-[#FFFFFF] pb-[12px]">
              Business Beyond Boundaries
            </h6>
            <p className="font-[400] md:text-[16px] text-[12px] md:leading-[24px] leading-[16px] text-[#FFFFFF] pb-[24px]">
              We foster a collaborative environment where businesses can connect, innovate, and grow without limitations.
            </p>
            {/* <div className="flex md:flex-row flex-col justify-between md:items-center items-start">
              <button className="relative font-[400] text-[16px] leading-[22px] text-center text-[#00725d] py-[11px] px-[27px] border border-[#FFFFFF] bg-[#FFFFFF] rounded-[50px] md:ml-[15px] ml-0">
                buy now
                <img
                  src="/assets/right-arrow.svg"
                  className="absolute right-[-28px] top-[50%] translate-y-[-50%]"
                  alt=""
                />
              </button>
              <div>
                <h6 className="text-[#FFFFFF] font-[700] text-[36px] md:text-right text-left pb-[6px]">
                  $29
                </h6>
                <p className="text-right font-[500] text-[16px] text-[#FFFFFF]">
                  24 Sold{" "}
                  <span className="text-[#f8a340]"> 12 Chapter 22 Min</span>
                </p>
              </div>
            </div> */}
          </div>
        </div>
        <div className="lg:grid-cols-3 grid md:grid-cols-2 grid-cols-1 gap-[30px]">
          <div className="relative">
            <img
              src="/assets/home/img4.png"
              className="w-full object-cover"
              alt=""
            />
            <img
              src="/assets/home/icon3.svg"
              className="absolute right-[20px] top-[20px]"
              alt=""
            />
            <h6 className="max-w-[206px] w-full font-[500] text-[#FFFFFF] text-[28px] leading-[33px] absolute bottom-[30px] left-[30px]">
              Growth Through Networking
            </h6>
          </div>
          <div className="relative">
            <img
              src="/assets/home/img5.png"
              className="w-full object-cover"
              alt=""
            />
            <img
              src="/assets/home/icon3.svg"
              className="absolute right-[20px] top-[20px]"
              alt=""
            />
            <h6 className="max-w-[206px] w-full font-[500] text-[#FFFFFF] text-[28px] leading-[33px] absolute bottom-[30px] left-[30px]">
              Knowledge & Skill Development
            </h6>
          </div>
          <div className="relative">
            <img
              src="/assets/home/img6.png"
              className="w-full object-cover"
              alt=""
            />
            <img
              src="/assets/home/icon3.svg"
              className="absolute right-[20px] top-[20px]"
              alt=""
            />
            <h6 className="max-w-[206px] w-full font-[500] text-[#FFFFFF] text-[28px] leading-[33px] absolute bottom-[30px] left-[30px]">
              Ethical & Transparent Practices
            </h6>
          </div>
        </div>
      </section>

      {/* <section className="md:my-[110px] my-[50px] relative">
        <img
          src="/assets/home/img7.png"
          className="w-full h-[600px] object-cover "
          alt=""
        />
        <div className="md:px-[135px] px-[20px] absolute top-0 md:pt-[63px] pt-[10px] w-full">
          <div className="flex md:items-center items-start md:gap-0 gap-[20px] justify-between md:flex-row flex-col md:pb-[156px] pb-[30px]">
            <div>
              <h6 className="font-[500] md:text-[48px] text-[20px] md:leading-[57.6px] lg:leading-[24px] text-[#FFFFFF] pb-[24px]">
              Benefits of Joining VNI
              </h6>
              <p className="max-w-[498px] w-full font-[400] text-[16px] leading-[24px] text-[#FFFFFF]">
              Joining VNI offers a unique opportunity to connect with like-minded professionals and expand your business network. Through structured meetings and interactive sessions, members build lasting relationships that foster growth and collaboration across industries.
              </p>
            </div>
            <button className="relative font-[400] text-[16px] leading-[22px] text-center text-[#00725d] py-[11px] px-[27px] border border-[#FFFFFF] bg-[#FFFFFF] rounded-[50px] ml-[15px]">
              Explore more
              <img
                src="/assets/right-arrow.svg"
                className="absolute right-[-28px] top-[50%] translate-y-[-50%]"
                alt=""
              />
            </button>
          </div>
          <div className="flex md:items-center items-start justify-between md:flex-row flex-col md:pb-[39px] pb-[30px]">
            <div>
              <p className="font-[500] text-[24px] leading-[30.6px] text-[#FF840099] pb-[6px]">
                December 2, 2024
              </p>
              <h6 className="font-[500] md:text-[48px] text-[20px] md:leading-[57.6px] leading-[24px] text-[#FFFFFF] pb-[24px]">
                Digital Marketing Bootcamp
              </h6>
              <p className="font-[400] md:text-[16px] text-[12px] leading-[24px] text-[#FFFFFF]">
              Beyond networking, VNI provides access to expert insights, industry trends, and mentorship programs designed to enhance business strategies. The supportive community encourages continuous learning and development, helping members refine their skills and stay ahead in a competitive market.

With a strong focus on transparency, ethics, and shared success, VNI creates an environment where businesses can thrive. By leveraging collective knowledge and resources, members unlock new opportunities and drive long-term growth.
              </p>
            </div>
            <h6 className="text-[#FFFFFF] font-[500] md:text-[48px] text-[20px] md:leading-[57.6px] leading-[24px] md:text-right text-left">
              $25.5
            </h6>
          </div>
          <div className="flex justify-between items-center">
            <button className="relative font-[400] text-[16px] leading-[22px] text-center text-[#00725d] bg-[#FFFFFF] py-[11px] px-[27px] border border-[#FFFFFF] rounded-[50px] ml-[15px]">
              Explore more
              <img
                src="/assets/right-arrow.svg"
                className="absolute right-[-28px] top-[50%] translate-y-[-50%]"
                alt=""
              />
            </button>
            <div className="flex items-center gap-[14px]">
              <button>
                <img src="/assets/home/left.svg" alt="" />
              </button>
              <button>
                <img src="/assets/home/right.svg" alt="" />
              </button>
            </div>
          </div>
        </div>
      </section> */}
      <div className="Benefits">
        <div className="overl">
          <h3>Benefits of Joining VNI</h3>


          <p >
            Joining VNI offers a unique opportunity to connect with like-minded professionals and expand your business network. Through structured meetings and interactive sessions, members build lasting relationships that foster growth and collaboration across industries.
            Beyond networking, VNI provides access to expert insights, industry trends, and mentorship programs designed to enhance business strategies. The supportive community encourages continuous learning and development, helping members refine their skills and stay ahead in a competitive market.

            With a strong focus on transparency, ethics, and shared success, VNI creates an environment where businesses can thrive. By leveraging collective knowledge and resources, members unlock new opportunities and drive long-term growth.

          </p>

          <button className="relative font-[400] text-[16px] leading-[22px] text-center text-[#00725d] py-[11px] px-[27px] border border-[#FFFFFF] bg-[#FFFFFF] rounded-[50px] ml-[15px]"
            style={{ marginTop: '70px' }}>
            Explore more
            <img
              src="/assets/right-arrow.svg"
              className="absolute right-[-28px] top-[50%] translate-y-[-50%]"
              alt=""
            />
          </button>
        </div>
      </div>
      <section className="md:px-[135px] px-[20px]">
        <div className="grid md:grid-cols-5 grid-cols-1 md:gap-[100px] gap-0">
          <div className="col-span-2">
            <h6 className="font-[500] text-[48px] leading-[57.6px] text-[#00725d]">
              What We <span className=" text-[#F8A340]">Offer</span>
            </h6>
          </div>
          <div className="col-span-3">
            <p className="font-[500] text-[36px] leading-[43.2px] text-[#00725d]">
              At VNI, we build <span className=" text-[#F8A340]"><b>relationships on trust, integrity, and a genuine commitment</b> </span> to the success of both our clients and team.
            </p>
          </div>
        </div>
        <div className="grid md:grid-cols-5 grid-cols-1 md:gap-[100px] gap-0 pt-[26px] gap-y-[30px]">
          <div className="col-span-2">
            <div className="flex gap-[20px] flex-col">
              <Accordion />
            </div>
          </div>
          <div className="col-span-3">
            <div className="grid md:grid-cols-2 grid-cols-1 gap-[77px]">
              <p className="font-[400] text-[16px] leading-[24px] text-[#00725d]">
                At every stage, we uphold the <span className=" text-[#F8A340]"><b>highest standards of excellence</b> </span>. From conception to execution, our commitment to perfection is evident in every detail. Precision, attention to detail, and an unwavering pursuit of quality set us apart.

              </p>
              <p className="font-[400] text-[16px] leading-[24px] text-[#00725d]">
                We foster a culture that encourages <span className=" text-[#F8A340]"><b>curiosity and professional growth,</b> </span>  ensuring our team remains at the forefront of innovation. By investing in our people, we equip them with <span className=" text-[#F8A340]"><b>cutting-edge insights and skills to serve our clients effectively</b> </span>.
                Aware of our global impact, we actively embrace sustainable business practices and engage with communities to create a positive and lasting difference.
              </p>
            </div>
            <button className="relative font-[400] mt-[42px] text-[16px] leading-[22px] text-center text-[#f8a340] py-[11px] px-[27px] border border-[#f8a340] rounded-[50px]">
              learn more
              <img
                src="/assets/right-arrow.svg"
                className="absolute right-[-28px] top-[50%] translate-y-[-50%]"
                alt=""
              />
            </button>
          </div>
        </div>
      </section>
      <section className="md:py-[110px] overflow-hidden py-[40px]">
        <ReviewSlider />
        <div className="pt-[33px]">
          <ReviewSlider2 />
        </div>
      </section>
      <section className="md:px-[135px] px-[20px]">
        <div className="md:grid-cols-5 grid-cols-1 md:gap-[100px] gap-0 gap-y-[30px] founder-div">
          <div className="founder-div-left">
            <h6 className="font-[500] text-[48px] leading-[58px] text-[#00725d] pb-[26px]">
              About <span className=" text-[#F8A340]">Founder</span>
            </h6>
            <p className="font-[400] text-[16px] leading-[24px] text-[#00725d] pb-[42px]">
              Mr. Arun Dabral is a seasoned professional with <span className=" text-[#F8A340]"><b>over 25 years of experience in finance, banking, insurance, business analysis, and marketing consulting .</b> </span> Holding a B.Sc. in PCM and a postgraduate degree in Economics , he has successfully established and managed three thriving companies , serving over <span className=" text-[#F8A340]"><b>1,000 clients</b> </span>  throughout his career. His expertise lies in guiding businesses toward financial freedom and sustainable growth. With a visionary approach, he aims to make every business debt-free while creating an automated marketing and sales ecosystem for <span className=" text-[#F8A340]"><b> clients, members, and associates.</b> </span> His passion for empowering entrepreneurs and businesses drives him to deliver innovative strategies that foster long-term success.
            </p>
            <button className="relative font-[400] mt-[42px] text-[16px] leading-[22px] text-center text-[#FFFFFF] bg-[#00725d] py-[11px] px-[27px] border border-[#00725d] rounded-[50px]">
              meet all members
              <img
                src="/assets/right-arrow.svg"
                className="absolute right-[-28px] top-[50%] translate-y-[-50%]"
                alt=""
              />
            </button>
          </div>
          <div className="founder-div-right flex gap-[30px]">
            <div
              className="blog-card"
              style={{ backgroundImage: "url(/assets/home/founder.jpeg)", backgroundPosition: 'center' }}
            >
              {/* <img src="/assets/home/item1.png" alt="" /> */}
              <div className="absolute content bg-[#00725d]  rounded-[20px] p-[20px] bottom-[20px]">
                <h6 className="font-[500] text-[15px] leading-[28px] text-[#FFFFFF] pb-[10px]">
                  Arun Dabral (CEO & Founder)
                </h6>
                <p className="font-[400] text-[12px] leading-[20px] text-[#FFFFFF]">
                  Finance and business expert with 25+ years of experience, empowers businesses with financial freedom and automated growth strategies.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>
      <section className="md:px-[135px] px-[20px] md:pt-[106px] pt-[60px]">
        <div className="flex items-center justify-between md:flex-row flex-col  md:pb-[60px] pb-[30px]">
          <div>
            <h6 className="font-[500] text-[48px] leading-[57.6px] text-[#00725d] pb-[24px]">
              Our News  <span className=" text-[#F8A340]">& Blogs</span>
            </h6>
            <p className="max-w-[498px] w-full font-[400] text-[16px] leading-[24px] text-[#00725d]">
              Beyond project completion, we stand steadfastly by your side,
              offering continuous support and adjustments as required.
            </p>
          </div>
          <button className="relative font-[400] text-[16px] leading-[22px] text-center text-[#FFFFFF] bg-[#00725d] py-[11px] px-[27px] border border-[#00725d] rounded-[50px] ml-[15px]">
            Explore more
            <img
              src="/assets/right-arrow.svg"
              className="absolute right-[-28px] top-[50%] translate-y-[-50%]"
              alt=""
            />
          </button>
        </div>
        <Blogs />
      </section>
      <section className="md:px-[120px] px-[20px] md:py-[110px] py-[40px]">
        <div className="md:px-[140px]">
          <h6 className="flex flex-wrap text-center justify-center pb-[44px] font-[500] md:text-[48px] text-[30px] md:leading-[58px] text-[#00725d] items-center">
            We offer solutions
            meticulously
            crafted to elevate your success.
          </h6>
        </div>
        <div className="flex justify-center items-center">
          <button className="relative font-[400] text-[16px] leading-[22px] text-center text-[#FFFFFF] bg-[#00725d] py-[11px] px-[27px] border border-[#00725d] rounded-[50px]">
            contact us
            <img
              src="/assets/right-arrow.svg"
              className="absolute right-[-28px] top-[50%] translate-y-[-50%]"
              alt=""
            />
          </button>
        </div>
      </section>
      <br />
      <br />
      <Gallery />
      <br />
      <br />

    </>
  );
}

export default Home;
